export const formatCurrency = (amount) => {
  const num = Number(amount) || 0;
  if (num >= 10000000) {
    return `₹${(num / 10000000).toFixed(2)} Cr`;
  } else if (num >= 100000) {
    return `₹${(num / 100000).toFixed(2)} L`;
  } else {
    return `₹${num.toLocaleString('en-IN')}`;
  }
};

// Alias for formatCurrency
export const formatINR = formatCurrency;

// Short format - same as formatCurrency (alias for compatibility)
export const formatCurrencyShort = formatCurrency;

// Detailed format - shows full number with commas
export const formatCurrencyDetailed = (amount) => {
  const num = Number(amount) || 0;
  return `₹${Math.round(num).toLocaleString('en-IN')}`;
};

export const formatCompact = (amount) => {
  const num = Number(amount) || 0;
  if (num >= 10000000) {
    return `₹${(num / 10000000).toFixed(1)} Cr`;
  } else if (num >= 100000) {
    return `₹${(num / 100000).toFixed(1)} L`;
  } else {
    return `₹${num.toLocaleString('en-IN')}`;
  }
};

export const formatToINR = (amount) => {
  const num = Number(amount) || 0;
  return `₹${Math.round(num).toLocaleString('en-IN')}`;
};

// Format commission - under 1L show as whole rupees, above show in L/Cr
export const formatCommission = (amount) => {
  const num = Number(amount) || 0;
  if (num >= 10000000) {
    return `₹${(num / 10000000).toFixed(2)} Cr`;
  } else if (num >= 100000) {
    return `₹${(num / 100000).toFixed(2)} L`;
  } else {
    // Under 1 lakh - round to whole rupees, no decimals
    return `₹${Math.round(num).toLocaleString('en-IN')}`;
  }
};
